
export default theme => ({
    root: {},
    refreshButton: {
      margin: -theme.spacing(2)
    },
    helpButton: {
      margin: -theme.spacing(2)
    },
    header: {
      height: '40px',
      color: theme.palette.text.secondary
    },
    stats: {
      marginTop: theme.spacing(2),
      display: 'flex',
      justifyContent: 'center'
    },
    device: {
      textAlign: 'center',
      padding: theme.spacing()
    },
    deviceIcon: {
      color: theme.palette.common.neutral
    },
    modal: {
        backgroundColor: 'white',
        border: '2px solid #000',
        width: '75vw',
        [theme.breakpoints.up('xs')]: {
            width: '75vw',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100vw',
        },
    },
    
  });